
<template>
  <m-layout>
    <div fill-height class="admin fill-height" style="width:100%; max-width:100%; position:relative">
      <v-btn icon text @click="sendAction('requestLocationPermission')">
        send
        <v-icon>

        </v-icon>
      </v-btn>
      <v-btn icon text @click="test()">
        test
      </v-btn>
      <m-snackbars></m-snackbars>

    <v-list subheader dense>
      <v-subheader>Users</v-subheader>
      <v-list-item-group v-model="selectedUsers">
        <v-list-item
          v-for="item in users"
          :key="item.id"
          :value="item"
          dense
        >
          <v-list-item-icon>
            <v-icon v-if="item.user.role === 'driver'" :color="item.user.active ? 'primary' : 'grey'">drive_eta</v-icon>
            <v-icon v-else-if="item.user.role === 'admin' || item.user.role === 'dispatch' || item.user.role === 'super'" color="primary">headset_mic</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title> {{ item.user.lastname}} ({{ item.user.id }})</v-list-item-title>
          </v-list-item-content>
          <v-list-item-action v-if="selectedUsers === item">


            <div class="mx-1" >
             <span v-if="item.user.role === 'driver'">
                <span class="mx-1" @click.stop="getInfo(item.user)"><v-icon small>info</v-icon></span>
                <span class="mx-1" @click.stop="doAction('getLocation', item.user.id)"><v-icon small>place</v-icon></span>
                <span class="mx-1" @click.stop="doAction('reloadApp')"><v-icon small>refresh</v-icon></span>
                <span class="mx-1" @click.stop="doAction('logoutApp')"><v-icon small>logout</v-icon></span>
                <span class="mx-1" @click.stop="doAction('moveToForeground')"><v-icon small>add_to_home_screen</v-icon></span>
                <span class="mx-1" @click.stop="doAction('checkPermission')"><v-icon small>live_help</v-icon></span>
                <span class="mx-1" @click.stop="doAction('appUpdated', '1.3.7')"><v-icon small>cloud_download</v-icon></span>
                <span class="mx-1" @click.stop="doAction('setInActive', true)"><v-icon small>block</v-icon></span>
                <span class="mx-1" @click.stop="doAction('setInActive', false)"><v-icon small>check</v-icon></span>
                <span class="mx-1" @click.stop="doAction('setEnabled', true)"><v-icon small>notification_add</v-icon></span>

              </span>
              <span v-else>
                <span class="mx-1" @click.stop="getInfo(item.user)"><v-icon small>info</v-icon></span>
                <span class="mx-1" @click.stop="doAction('reloadApp')"><v-icon small>refresh</v-icon></span>
                <span class="mx-1" @click.stop="doAction('logoutApp')"><v-icon small>logout</v-icon></span>
              </span>
              <span class="mx-1" @click.stop="forceDisconnect(item)"><v-icon small>close</v-icon></span>
              </div>
          </v-list-item-action>
        </v-list-item>
      </v-list-item-group>
    </v-list>

    </div>
    <div id="mapHolder" class="google-map"></div>
  </m-layout>
</template>
<script>
import styles from '@/components/googlemaps/styles';
import MSnack from "@/components/notification/snackbars";
export default {
  components: {
    "m-snackbars": MSnack
  },
  data () {
    return {
      newMsg: '',
      selectedUsers: null,
      map: null,
    };
  },
  methods: {
    test () {
      //this.$api.update();
      this.doSay();
    },
    doSay() {
      console.log('doSay()');
      this.$socket.client.emit('test', 'Hello from dispatcth');
    },
    getInfo(to) {
      console.log('getInfo', to);
      this.sendAction('getInfo', to.id);
    },
    forceDisconnect(to) {
      console.log('send a disconnect', to);
      this.$socket.client.emit('forceDisconnect', {
        to: to.socketId || null,
        from: this.user.id || null,
      });
    },
    openPrivate(to) {
      console.log('openPrivate', to);
    },
    openActions(to) {
      console.log('openActions', this.selectedUsers);
      if (this.selectedUsers) {
        this.sendAction('checkPermission', this.selectedUsers.user.id, 3);
      }
    },
    doAction(action, data) {
      console.log(action, this.selectedUsers, data);
      if (this.selectedUsers) {
        var to = this.selectedUsers.user.id;
        this.sendAction(action, to, data);
      }
    },
    sendAction(action, to, data) {
      console.log(action);
      this.$socket.client.emit('action', {
        to: to || 'all',
        from: this.user.id || 'all',
        action: action,
        data: data || null
      });
    },
    showPosition(data) {
      console.log('showPosition:', data);
      var position = new google.maps.LatLng(data.info.position.latitude, data.info.position.longitude);
      this.map.panTo(position);
      new google.maps.Marker({
        position,
        map: this.map
      });
    }
  },
  mounted () {
    const element = document.getElementById('mapHolder');
    const options = {
      zoom: 13,
      mapTypeControl: false,
      center: { lat: 50.86, lng: 4.3517 },
      styles: (styles && styles.simple) || null
    };
    this.map = new google.maps.Map(element, options);
  },
  sockets: {
    // online (data) {
    //   console.log('admin - online:', data);
    //   data.clients.forEach((item) => {
    //     console.log('socket ids:', item.socketId);
    //   });
    // },
    say (data) {
      console.log('say:', data);
      if (data && data.info && data.info.position){
        this.showPosition(data);
      } else if (data.data && data.data.latitude) {
        this.showPosition({info: {position: data.data}});
      } else if (data.data && data.data.coords) {
        this.showPosition({info: {position: data.data.coords}});
      }
    }
  },
  watch: {
    users () {
      //console.log('admin: users changed');
    }
  },
  computed: {
    users: {
      cache: false,
      get () {
        var c = this.$store.getters.socket_clients;
        if (c) {
          return this.$store.getters.socket_clients.filter((item) => item.user ).map((item) => {
            if (item.user) {
              item.user.socket = item.socketId;
            }
            return item;
          });
        } else return [];
      }
    },
    user: {
      cache: false,
      get () {
        return this.$store.getters.user
      }
    }
  }
};
</script>
<style lang="scss">
.admin {
    .google-map {
      width: 100%;
      max-height: 250px;
      margin: 20px auto;
      background: rgb(241, 240, 240);
      border: 1px solid rgb(221, 219, 219);
    }
    .m-tools {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    }
  .theme--light.v-data-table {
    background-color: transparent;
  }
}
</style>
